import React, {useEffect, useState} from 'react';
import {useParams, useNavigate} from 'react-router-dom';
import {useMutation} from '@apollo/client';
import {VERIFY_ACCOUNT_MUTATION} from "../../graphql/auth";

const VerifyAccount = () => {
    const params = useParams();

    const [message, setMessage] = useState('');

    const [verifyAccount] = useMutation(VERIFY_ACCOUNT_MUTATION);

    const navigate = useNavigate();

    useEffect(async () => {
        const { data } = await verifyAccount({
            variables: {
                $token: params.token
            }
        });

        setMessage(data.forgotPassword.message);

        setTimeout(() => {
            navigate('/', { replace: true });
        }, 3000);
    }, []);

    return (
        <div className="self-center w-full">
            <div className="bg-white shadow rounded-lg p-6">
                <div className="grid grid-cols-1 gap-6">
                    <div className="mx-auto">
                        <h1 className="mx-auto justify-center text-blue-600 font-black text-2xl">Verify Account</h1>
                    </div>

                    {message !== '' ? (
                        <div className="justify-center text-center w-full text-green-700 bg-green-100">
                            {message}
                        </div>) : <></>}
                </div>
            </div>
        </div>
    );
};

export default VerifyAccount;